import React from "react";

function Navigation() {
    return <div id="top" className="content"> </div>;
}

export default Navigation;
